module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-HeavyItalic.d6d8ac36.ttf";